import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BulkTaggingModal from 'components/modals/bulk_tagging_modal';

import { bulkTagging, endBulkTagging, setBulkTags } from "../../store/actions/companies";

export class Companies1BulkTaggingModal extends React.Component {

  static propTypes = {
    bulkTags: PropTypes.array.isRequired,
    selectedCompanyIds: PropTypes.array.isRequired,
    startBulkTagging: PropTypes.bool.isRequired,
    tagsPaths: PropTypes.object.isRequired,
    onBulkTagging: PropTypes.func.isRequired,
    onCancelBulkTagging: PropTypes.func.isRequired,
    onSetBulkTags: PropTypes.func.isRequired,
  };

  render() {
    const {
      bulkTags,
      onSetBulkTags,
      selectedCompanyIds,
      startBulkTagging,
      tagsPaths,
      onBulkTagging,
      onCancelBulkTagging
    } = this.props;

    const count = selectedCompanyIds.length;

    return (
      <BulkTaggingModal
        buttonText={"Bulk Tag " + count + (count > 1 ? " Companies" : " Company")}
        paths={tagsPaths}
        selectedIds={selectedCompanyIds}
        shown={startBulkTagging}
        tags={bulkTags}
        onBulkTag={onBulkTagging}
        onCancel={onCancelBulkTagging}
        onSetBulkTags={onSetBulkTags}
      />
    );
  }
}

const mapStateToProps = state => ({
  bulkTags: state.companies.bulkTags,
  startBulkTagging: state.companies.startBulkTagging,
  selectedCompanyIds: state.selectList.selectedCompanyIds,
  tagsPaths: state.paths.tags
});

const mapDispatchToProps = {
  onBulkTagging: bulkTagging,
  onCancelBulkTagging: endBulkTagging,
  onSetBulkTags: setBulkTags,
};

export default connect(mapStateToProps, mapDispatchToProps)(Companies1BulkTaggingModal);
